<div class="reference-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>{{ getTitle() }}</h2>
    <button mat-icon-button (click)="onClose()" class="close-button" [disabled]="loading()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <form [formGroup]="form">
      @if (dialogType === 'reference') {
        <!-- Reference Type Fields -->
        <mat-form-field class="full-width">
          <mat-label>Type</mat-label>
          <mat-select formControlName="type" required [disabled]="loading()">
            <mat-option *ngFor="let type of referenceTypes"
            [value]="type.value">  {{ type.label }}
            </mat-option>
          </mat-select>
          <mat-error>Type is required</mat-error>
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>Reference Number</mat-label>
          <input matInput formControlName="number" required [disabled]="loading()" />
          <mat-error>Reference Number is required</mat-error>
        </mat-form-field>

        @if (isEditMode) {
          <mat-form-field class="full-width">
            <mat-label>Description</mat-label>
            <textarea matInput formControlName="description" rows="3" [disabled]="loading()"></textarea>
          </mat-form-field>

          <mat-form-field class="full-width">
            <mat-label>Status</mat-label>
            <input matInput formControlName="status" [disabled]="loading()" />
          </mat-form-field>

          <mat-form-field class="full-width">
            <mat-label>Link</mat-label>
            <input matInput formControlName="link" [disabled]="loading()" />
          </mat-form-field>
        }
      } @else {
        <!-- TLR Entry Fields -->
        <mat-form-field class="full-width">
          <mat-label>Tag</mat-label>
          <input matInput formControlName="tag" required [disabled]="loading()" />
          <mat-error>Tag is required</mat-error>
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>TLR Type</mat-label>
          <mat-select formControlName="tlrType" required [disabled]="loading()">
            <mat-option *ngFor="let type of tlrTypes" [value]="type[0]">
              {{ type[1] }}
            </mat-option>
          </mat-select>
          <mat-error>TLR Type is required</mat-error>
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>TA Scope</mat-label>
          <mat-select formControlName="taScope" required [disabled]="loading()">
            <mat-option *ngFor="let scope of taScopes" [value]="scope[0]">
              {{ scope[1] }}
            </mat-option>
          </mat-select>
          <mat-error>TA Scope is required</mat-error>
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>Equipment/Process/Service</mat-label>
          <mat-select formControlName="equipmentProcessService" required [disabled]="loading()">
            <mat-option>
              <ngx-mat-select-search
                placeholderLabel="Search..."
                noEntriesFoundLabel="No matching equipment found"
                [formControl]="queryControl"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let equipment of equipmentProcessServices" [value]="equipment[0]">
              {{ equipment[1] }}
            </mat-option>
          </mat-select>
          <mat-error>Equipment/Process/Service is required</mat-error>
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>Date TLR Installed</mat-label>
          <input matInput [matDatepicker]="installedPicker" formControlName="dateTlrInstalled" required [disabled]="loading()" />
          <mat-datepicker-toggle matSuffix [for]="installedPicker"></mat-datepicker-toggle>
          <mat-datepicker #installedPicker></mat-datepicker>
          <mat-error>Date TLR Installed is required</mat-error>
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>Recommended Permanent Repair Date</mat-label>
          <input matInput [matDatepicker]="repairPicker" formControlName="recommendedPermanentRepairDate" required [disabled]="loading()" />
          <mat-datepicker-toggle matSuffix [for]="repairPicker"></mat-datepicker-toggle>
          <mat-datepicker #repairPicker></mat-datepicker>
          <mat-error>Recommended Permanent Repair Date is required</mat-error>
        </mat-form-field>
      }
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    @if (loading()) {
      <mat-spinner diameter="24" style="margin-right: 16px;"></mat-spinner>
    }
    <button mat-button (click)="onClose()" [disabled]="loading() ">Close</button>
    <button mat-raised-button color="primary" (click)="onAdd()" [disabled]="!form.valid || loading() || getCancelPermission()">
      {{ isEditMode ? 'Update' : 'Add' }}
    </button>
  </mat-dialog-actions>
</div>
